/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { I18NBulkUpsertDto } from '../../models/i-18-n-bulk-upsert-dto';

export interface I18NAdminControllerBulkUpsertV1$Params {
      body: I18NBulkUpsertDto
}

export function i18NAdminControllerBulkUpsertV1(http: HttpClient, rootUrl: string, params: I18NAdminControllerBulkUpsertV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * 생성된 항목 수
 */
'created'?: number;

/**
 * 수정된 항목 수
 */
'updated'?: number;
}>> {
  const rb = new RequestBuilder(rootUrl, i18NAdminControllerBulkUpsertV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * 생성된 항목 수
       */
      'created'?: number;
      
      /**
       * 수정된 항목 수
       */
      'updated'?: number;
      }>;
    })
  );
}

i18NAdminControllerBulkUpsertV1.PATH = '/api/v1/i18n/admin/bulk';
